import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "pro-sidebar-collapsed"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    const collapsed = localStorage.getItem(STORAGE_KEY) === "true"
    this.apply(collapsed, { persist: false })
  }

  toggle() {
    this.apply(!this.collapsed, { persist: true })
  }

  get collapsed() {
    return this.element.classList.contains("pro-app-shell--sidebar-collapsed")
  }

  apply(collapsed, { persist }) {
    this.element.classList.toggle("pro-app-shell--sidebar-collapsed", collapsed)

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", collapsed ? "false" : "true")
      const expandLabel = this.toggleTarget.dataset.expandLabel
      const collapseLabel = this.toggleTarget.dataset.collapseLabel
      if (expandLabel && collapseLabel) {
        this.toggleTarget.setAttribute("aria-label", collapsed ? expandLabel : collapseLabel)
      }
    }

    if (persist) {
      localStorage.setItem(STORAGE_KEY, collapsed ? "true" : "false")
    }
  }
}
